@if (relatedTeaser().items.length > 0) {
  <hr class="col-1-12 ms-medium-b" />
}
<div class="col-1-12" data-elastic-exclude>
  @for (article of relatedTeaser().items; track article.contentId) {
    <div class="related-article ms-small-b">
      <a class="no-underline" (click)="emitClick()" [finLink]="article.url">
        <div class="related-title nordic-blue-900-text text-icon-primary ps-xxsmall-t font-label-medium">
          {{ article.teaserTitle }}
        </div>
        <fin-date [date]="article.externallyDisplayedDate" />
      </a>
    </div>
  }
</div>
